import { render, staticRenderFns } from "./company-info-cn.vue?vue&type=template&id=7365f70f&"
import script from "./company-info-cn.vue?vue&type=script&lang=js&"
export * from "./company-info-cn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports